<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex justify-content-between align-items-center mb-3 pt-3">
      <app-main-heading [heading]="'Tyre Pattern'" class="m-0"></app-main-heading>
    </div>

    <div class="row g-2 mb-3 align-items-center justify-content-end">
      <div class="col-6 col-md-3">
        <div class="search-wrapper position-relative w-100">
          <input type="text" class="form-control search-input" placeholder="Search Tyre Pattern"
            style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
            #name (input)="FilterList(make.value, size.value, name.value)">
          <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
            style="pointer-events: none; font-size: 13px;"></fa-icon>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="search-wrapper position-relative w-100">
          <input type="text" class="form-control search-input" placeholder="Search Tyre Make"
            style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
            #make (input)="FilterList(make.value, size.value, name.value)">
          <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
            style="pointer-events: none; font-size: 13px;"></fa-icon>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="search-wrapper position-relative w-100">
          <input type="text" class="form-control search-input" placeholder="Search Tyre Size"
            style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
            #size (input)="FilterList(make.value, size.value, name.value)">
          <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
            style="pointer-events: none; font-size: 13px;"></fa-icon>
        </div>
      </div>
      <div class="col-6 col-md-auto">
        <button class="btn app-btn-primary w-100"
          style="height: 38px; display: flex; align-items: center; justify-content: center;"
          (click)="tyreModelFormPopup()">Add Tyre Pattern</button>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none mb-2">
      <div class="table-responsive app-scrollbar" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="300" (scrolled)="listScroll()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header text-nowrap">
              <th scope="col">Pattern</th>
              <th scope="col">Brand</th>
              <th scope="col">Size</th>
              <th scope="col">Speed</th>
              <th scope="col">Load Index</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          @if (modelList.length >=1) {
          <tbody infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="listScroll()">
            <ng-container>
              @for (list of modelList; track list; let modelIndex = $index) {
              @if (list.tyreDetails && list.tyreDetails.length > 0) {
              @for (tyreDetail of list.tyreDetails; track tyreDetail; let i = $index) {
              <tr class="app-table-body app-td-text">
                @if (i === 0) {
                <td [attr.rowspan]="list.tyreDetails.length" class="td-text-three">{{ list.name }}</td>
                }
                @if (i === 0) {
                <td [attr.rowspan]="list.tyreDetails.length" class="td-text-two">{{ list.tyreMake }}</td>
                }
                <td class="td-text-two">{{ tyreDetail.tyreSize }}</td>
                <td class="speed td-text-two text-muted">{{ tyreDetail.speed }}</td>
                <td class="td-text-one">{{ tyreDetail.loadIndex }}</td>
                @if (i === 0) {
                <td [attr.rowspan]="list.tyreDetails.length" class="icons">
                  @if (list.description && list.description.trim() !== '') {
                  <fa-icon [icon]="faInfo" class="btn app-btn-primary right" ngbTooltip="Description"
                    [placement]="'top'" (click)="descriptionOverlay(modelIndex)"></fa-icon>
                  }
                  <fa-icon [icon]="faEdit" class="btn app-btn-primary btn-sm" ngbTooltip="Edit" [placement]="'top'"
                    (click)="editTyreModel('edit',list)"></fa-icon>
                </td>
                }
              </tr>
              }
              }
              }
            </ng-container>
          </tbody>
          }
          <!-- Loader Row -->
          @if (loader) {
          <tbody>
            <tr>
              <td colspan="6">
                <div class="custom-col-width-100 d-flex justify-content-center py-5">
                  <app-loader [loadingIcon]="loader"></app-loader>
                </div>
              </td>
            </tr>
          </tbody>
          }

          <!-- Empty State Row -->
          @if (!loader && modelList.length === 0) {
          <tbody>
            <tr>
              <td colspan="6">
                <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                  No Records Found!
                </div>
              </td>
            </tr>
          </tbody>
          }
        </table>
      </div>
    </div>
  </div>


  @if (showEditMakePopup) {
  <div class="popup-overlay">
    <div class="popup-container">
      <h3>{{popupType}} Tyre Pattern</h3>
      <form [formGroup]="addTyreModelForm" (ngSubmit)="saveVehicleModel()">
        <div class="row pt-2 g-2">
          <div class="col-12 col-md-6 mb-2 custom-name">
            <label for="name" class="form-label cus">Name<span class="text-danger">*</span></label>
            <input formControlName="name" id="name" type="text" class="form-control default-form-group-border" required
              placeholder="Enter tyre pattern">
            @if (addTyreModelForm.get('name')?.invalid && addTyreModelForm.get('name')?.touched) {
            <div>
              <small class="text-danger">Tyre pattern name is required</small>
            </div>
            }
          </div>
          <div class="col-12 col-md-6 mb-2 custom-tyre">
            <label for="tyreMakeSelect" class="form-label">Tyre Make<span class="text-danger">*</span></label>
            <ng-select labelForId="tyreMakeSelect" [items]="makeList" bindLabel="name" bindValue="name" [multiple]="false" [clearable]="true"
              [searchable]="true" placeholder="Search or Select Tyre Make" formControlName="tyreMake"
              class="ng-select-bootstrap" dropdownClass="tyre-model-dropdown-panel" [searchFn]="customSearchFn"
              (search)="onTyreMakeInputChange($event)" (scrollToEnd)="onScroll()">
            </ng-select>
          </div>
          <div class="col-12 mb-2">
            <label for="descTextarea" class="form-label">Description</label>
            <textarea id="descTextarea" formControlName="description" class="form-control description-textarea default-form-group-border"
              placeholder="Description"></textarea>
          </div>
        </div>
        @for (detail of tyreDetails.controls; track detail; let i = $index) {
        <div formArrayName="tyreDetails">
          <div [formGroupName]="i" class="row pt-2 g-2 align-items-end mb-2">
            <div class="col-6 col-md-2 mb-2">
              <label [attr.for]="'speedInput_' + i" class="form-label">Speed</label>
              <input [id]="'speedInput_' + i" formControlName="speed" type="text" class="form-control small-input default-form-group-border"
                placeholder="Eg: H">
            </div>
            <div class="col-6 col-md-2 mb-2">
              <label [attr.for]="'loadIndexInput_' + i" class="form-label">Load Index</label>
              <input [id]="'loadIndexInput_' + i" formControlName="loadIndex" type="number"
                class="form-control small-input default-form-group-border" placeholder="Enter load index"
                (input)="onInput($event)">
            </div>
            <div class="col-9 col-md-6 mb-2">
              <label [attr.for]="'tyreSizeSelect_' + i" class="form-label">Tyre Size</label>
              <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSize[i].list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
                [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size"
                formControlName="tyreSize" class="ng-select-bootstrap" dropdownClass="tyre-model-dropdown-panel"
                [searchFn]="customSearchFn" (search)="onTyreSizeInputChange($event, i)" (scrollToEnd)="scroll(i)">
              </ng-select>
            </div>
            <div class="col-3 col-md-2 mb-2 d-flex align-items-end gap-2 justify-content-end">
              @if (i == tyreDetails.length - 1) {
              <button class="btn app-btn-primary m-0" type="button" (click)="addMoreTyreDetails(i)">
                <fa-icon [icon]="faPlus" [ngbTooltip]="'Add'" class="fa-1.5x"></fa-icon>
              </button>
              }
              @if (tyreDetails.length > 1) {
              <button class="btn btn-danger m-0" type="button" (click)="removeTyreDetails(i)">
                <fa-icon [icon]="faTrash" [ngbTooltip]="'Delete'" class="fa-1.5x"></fa-icon>
              </button>
              }
            </div>
          </div>
        </div>
        }
        @if (errorMessage) {
        <div>
          <p class="error-text">{{ errorMessage }}</p>
        </div>
        }
        <!-- Action Buttons -->
        <div class="row pt-3">
          <div class="col-12 d-flex justify-content-end gap-2 button_section">
            <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
            <button type="submit" class="btn app-btn-primary sub_button" [disabled]="addTyreModelForm.invalid">
              {{popupType}}
              @if (isLoading) {
              <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  }

  @if (descriptionPopup) {
  <div class="popup-overlay">
    <div class="overlay-content">
      <div class="card">
        <div class="card-body">
          <h3>Description</h3>
          <p>{{ message }}</p>
          <div class="button-container">
            <button type="button" class="btn pr-2" (click)="closeOverlay()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</section>

@if (isToster) {
<app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}